<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-calendar-check-o  text-primary"></i> Attendance</h5>
      </div>
      <hr>
      <div class="row g-3">
           <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id"  @change="listData()">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <div class=" col-md-3">
          <label for="inputclassname" class="form-label">Section<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select v-model="Obj.sectionID" class="form-select form-select-sm rounded cursor-pointer" role="button" @change="listData()">
            <option selected=""></option>
            <option v-for="(item, index) in
              secList" :key="index" :value="item._id"> {{ item.Name }} </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Subject :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.subjectID">
            <option selected=""></option>
            <option v-for="(item, index) in allSubjects" :key="index" :value="item._id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="col-md-3 position-relative">
          <label class="form-label">Student :</label>
          <select v-model="Obj.studentID" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option v-for="(item, index) in
              List1" :key="index" :value="item._id"> {{ item.firstName }}  {{ item.lastName }}  </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="date" class="form-control form-control-sm" v-model="Obj.attndDate">
        </div>
      <div class="col-md-9 mt-md-5 mt-2 text-end">
          <button class="btn btn-sm btn-success  me-1" @click="save()"><i
              class=" fa fa-search text-white me-1"></i> Go</button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="clearForm()"><i class="fa fa-times-circle  me-1"></i> Clear</button>
        </div>
      </div>
       <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row" v-if="showTable">
        <div v-if="progress==0 && List.length === 0"
              class="text-start py-4 fw-bold">
            No Records...
          </div>
        <div class="col-sm-12  mt-2 table-responsive">
       <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
       </div>
          <table id="example" class="table table-bordered custom-table" v-if="progress==0 && List.length> 0">
            <thead>
              <tr>
                <th>Roll No</th>
                <th>Status</th>
                <th>Name</th>
                <th>Attend</th>
                <th>Class</th>
                <th style="width:0px;">Photo</th>
                <th>Date</th>
                <th>Subject</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in List" :key="index">
                <td>{{ item.rollNo }}</td>
                <td>
                  <label class="switch">
              <input type="checkbox" :checked="item.status === true" :disabled="!Obj.subjectID" 
              :id="'toggleSwitch' + index" @change="updateStatus($event, item)" style="width:3em;height:25px" >
               <span class="slider round"></span>
              </label> 
                </td>
                <td>{{ item.firstName || 'N/A'}} {{ item.lastName }}</td>
                <td>
                  <div class="d-flex gap-1">
                    <span v-if="item.status" class="badge bg-success fw-normal">Present</span>
                    <span v-else class="badge bg-danger fw-normal">Absent</span>
                  </div>
                </td>
                <td> {{ clsList.find(cls => cls._id == item.clsID) && secList.find(cls => cls._id == item.sectionID)
                    ? `${clsList.find(cls => cls._id == item.clsID)?.name}  (${secList.find(cls => cls._id == item.sectionID)?.Name})` : '' }}
                </td>
                <td style="padding:0px;">
                  <div class="img-hover-container d-inline-block position-relative cursor-pointer" role="button">
                    <img :src="getUrl(item.image)" class="w-100 h-25 img-thumbnail-a" alt="student Image" />
                    <div class="img-preview-a p-0 w-0 bottom-0 position-absolute bg-white shadow">
                      <img :src="getUrl(item.image)" class=" h-100 img-thumbnail-a" alt="student Image" />
                    </div>
                  </div>
                </td>
                <td>{{ disDate(item.attndDate) }}</td>
                <td> {{ allSubjects.find(sub => sub._id === item.subjectID)?.name || "N/A" }} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { formatDate, api } from '@/utils/helpers.js';
import { ref, onMounted, computed} from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList,  subList } = schoolStore();
const allSubjects = computed(() => {
  if (!Obj.value.clsID) return []; 
  return subList.value.filter(sub => sub.clsID === Obj.value.clsID);
});
  const  Obj = ref( { clsID: "", sectionID: "", subjectID: "", studentID: "", attndDate: new Date().toISOString().slice(0, 10) })
   const List1= ref([])
   const List= ref([])
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   errors= ref({})
    const   errors1= ref({})
    const showTable= ref(false)
    const disDate= (d)=> { return formatDate(d) }
const listData= async()=> {
      const fields = {
        clsID: { value: Obj.value.clsID, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], }
      };
      errors1.value = validateForm(fields);
      if (Object.keys(errors1.value).length === 0) {
        await api .get(`/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}`)
        .then((res) => { List1.value = res.data });
      }
    }
    const updateStatus = async (event, item) => {
  const newStatus = event.target.checked;
 const updated = {
  studentID: item._id,
  clsID: item.clsID,
  sectionID: item.sectionID,
  subjectID: Obj.value.subjectID || item.subjectID, 
  attndDate: new Date(item.attndDate).toISOString().slice(0, 10),
  status: newStatus,
};

  try {
    await api.post(`/attendance/add`, updated);
    item.status = newStatus; 
    msgObj.value = {
      msg: "Status updated successfully.",
      role: "success",
      show: true,
    };
  } catch (error) {
    console.error("Status update error:", error.response?.data || error.message);
    msgObj.value = {
      msg: error.response?.data?.message || "Failed to update status.",
      role: "danger",
      show: true,
    };
    event.target.checked = !newStatus; 
  }
};
const save = async () => {
  const fields = {
    Class: { value: Obj.value.clsID, validators: [isRequired], },
    Section: { value: Obj.value.sectionID, validators: [isRequired], },
    Date: { value: Obj.value.attndDate, validators: [isRequired], },
  };
  errors.value = validateForm(fields);
  const selectedDate = new Date(Obj.value.attndDate);
  const today = new Date();
  if (selectedDate > today) {
    msgObj.value = { msg: "Attendance cannot be marked for future dates.", role: "danger", show: true, };
    return;
  }
  if (Object.keys(errors.value).length === 0) {
    try {
      if (!Obj.value.subjectID) {
        const res = await api.get(
          `/students/list?clsID=${Obj.value.clsID}&sectionID=${Obj.value.sectionID}`
        );
        let students = res.data;
        if (Obj.value.studentID) {
          students = students.filter(s => s._id === Obj.value.studentID);
        }
        let allRows = [];
        for (let student of students) {
          for (let subj of allSubjects.value) {
            let row = { ...student, attndDate: Obj.value.attndDate, subjectID: subj._id, status: false, };
            try {
              const response = await api.get(
                `/Attendance/status/${student.clsID}/${student.sectionID}/${student._id}/${subj._id}/${Obj.value.attndDate}`
              );
              row.status = response.data.status;
            } catch (err) { row.status = false; }
            allRows.push(row);
          }
        }
        List.value = allRows;
        showTable.value = true;
        return;
      }
      const res = await api.get(
        `/students/list?clsID=${Obj.value.clsID}&sectionID=${Obj.value.sectionID}&subjectID=${Obj.value.subjectID}`
      );
      let filteredStudents = res.data.map((student) => ({
        ...student,
        attndDate: Obj.value.attndDate,
        subjectID: Obj.value.subjectID,
        status: student.status ?? false,
      }));

      if (Obj.value.studentID && Obj.value.studentID !== "") {
        filteredStudents = filteredStudents.filter(
          (s) => s._id === Obj.value.studentID
        );
      }
      await Promise.all(
        filteredStudents.map(async (item) => {
          try {
            const response = await api.get(
              `/Attendance/status/${item.clsID}/${item.sectionID}/${item._id}/${Obj.value.subjectID}/${Obj.value.attndDate}`
            );
            item.status = response.data.status;
          } catch (error) {
            item.status = false;
          }}));
      List.value = filteredStudents;
      showTable.value = true;
    } catch (error) {
      console.error("Error loading student list:", error);
    }
  }
};
const clearForm= () => {
  Obj.value = { clsID: "", sectionID: "", subjectID: "", studentID: "", attndDate: new Date().toISOString().slice(0, 10), status: "", };
  errors.value={};
    showTable.value= false;
}
 const progress = ref(0)
const loadData= async() => {
      let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
  await api.get('/Attendance/all')
    .then((response) => { List.value = response.data;
        progress.value = 0
          clearInterval(progressInterval)
     });
}
const getUrl= (img) => {
  let imgUrl = !img
    ? "/images/default.png"
    : img.startsWith("..")
      ? img.substring(2)
      : img;
 
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
  onMounted(() => { loadData() })
</script>
<style>
.img-preview-a {
  display: none;
  top: -30px;
  left: 105%;
  border: 1px solid #f3f3f3;
  background-color: white;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
}
.img-hover-container:hover .img-preview-a {
  display: block;
}
.img-preview-a img {
  max-width: 135px;
  max-height: 140px;
  object-fit: fill;
}
.img-thumbnail-a {
    padding: 0.25rem;
    background-color: white;
    border-radius: 5px;
    max-width: 100%;
    max-height: 45px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0;
  right: 0; bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: blue;
}
input:checked + .slider:before {
  transform: translateX(26px);
}
</style>